<ng-container *ngIf="data$ | async as data">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 447.5" preserveAspectRatio="none">
    <polygon [attr.fill]="bottomColor" points="0,447.5 600,447.5 600,115.5 0,445.5 "></polygon>
  </svg>
</ng-container>
